import React, { useContext } from "react";
import EditModal from "../../profiles/EditModal";
import HeaderForm from "./header_form";
import MainContentForm from "./main_content_form";
import { CompanyContext } from "../data/company_context_management";
import PrProfilesForm from "./pr_profiles_form";
import PrAgenciesForm from "./pr_agencies_form";
import ExpertsForm from "./experts_form";
import PrTeamForm from "./pr_team_form";
import BrandsForm from "./brands_form";

// Company's edit modal: consumes the shared <EditModal> shell (chrome only) and keeps the
// engine-specific section -> form-body mapping + title here in Frontend. The dead
// CONTACT_INFO label was dropped (it had no form body — an empty-modal dead end).
function CompanyEditModal() {
  const { company, openEditModal, setOpenEditModal } = useContext(CompanyContext);
  const closeModal = () => {
    setOpenEditModal(null);
  };

  const headerSectionLabel = () => {
    switch (openEditModal) {
      case "HEADER":
        return " - Header Details";
      case "MAIN":
        return " - Main Content";
      case "PR_PROFILES":
        return " - Our PR Representatives";
      case "PR_AGENCIES":
        return " - Our PR Agencies";
      case "EXPERTS":
        return " - Company Experts";
      case "PR_TEAM":
        return " - Our PR Team";
      case "BRANDS":
        return " - Our Brands";
      default:
        return null;
    }
  };

  return (
    <EditModal
      show={!!openEditModal}
      onClose={closeModal}
      title={
        <>
          Editing {company.name} {headerSectionLabel()}
        </>
      }
    >
      {openEditModal === "HEADER" && <HeaderForm />}
      {openEditModal === "MAIN" && <MainContentForm />}
      {openEditModal === "PR_PROFILES" && <PrProfilesForm />}
      {openEditModal === "PR_AGENCIES" && <PrAgenciesForm />}
      {openEditModal === "EXPERTS" && <ExpertsForm />}
      {openEditModal === "PR_TEAM" && <PrTeamForm />}
      {openEditModal === "BRANDS" && <BrandsForm />}
    </EditModal>
  );
}

export default CompanyEditModal;
